const initialState = {
  uri: "https://a-api.nextopup.com/v3/",
  isloading: false,
  isPending: false,
  isIdTarget: "",
  isSideBar: false,
  isSearch:false,
  isMaintenanceMode: false,
  isToManyRequestMode: false,
};
const todoReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "ISLOADING":
      return {
        ...state,
        isloading: payload,
      };
    case "ISPENDING":
      return {
        ...state,
        isPending: payload,
      };
    case "ISTARGET":
      return {
        ...state,
        isIdTarget: payload,
      };
    case "ISSIDEBAR":
      return {
        ...state,
        isSideBar: payload,
      };
    case "ISMAINTENANCEMODE":
      return {
        ...state,
        isMaintenanceMode: payload,
      };
      case "ISTOMANYREQUESTMODE":
        return {
          ...state,
          isToManyRequestMode: payload,
        };
        case "ISSEARCH":
          return {
            ...state,
            isSearch: payload,
          };
    default:
      return {
        ...state,
      };
  }
};
export default todoReducer;
